export default {
  ZH_HK: {
    tip: "題目已就緒，\r\n請選擇答題遊戲",
    selectGame: "選擇遊戲",
    link: "鏈接",
    copy: "複製",
    noGame: "沒有可用遊戲",
    close: "關閉",
    confirm: "確認",
    copied: "已複製",
    copiedError: "複製失敗",
    gamePathError: "遊戲路徑無效"
  },
  zh_cn: {
    tip: "题目已就绪，\r\n请选择答题游戏",
    selectGame: "选择游戏",
    link: "链接",
    copy: "复制",
    noGame: "没有可用游戏",
    close: "关闭",
    confirm: "确认",
    copied: "已复制",
    copiedError: "复制失败",
    gamePathError: "游戏路径无效"
  },
  EN: {
    tip: "The questions are ready,\r\n please select the game to answer",
    selectGame: "Select Game",
    link: "Link ",
    copy: "Copy",
    noGame: "No available games found",
    close: "Close",
    confirm: "Confirm",
    copied: "Copied",
    copiedError: "Error in copying",
    gamePathError: "The game path is invalid"
  },
  es: {
    tip: "Las preguntas están listas. Por favor, \r\nselecciona un juego de preguntas",
    selectGame: "Seleccionar juego",
    link: "Enlace",
    copy: "Copiar",
    noGame: "No hay juegos disponibles",
    close: "Cerrar",
    confirm: "Confirmar",
    copied: "Copiado",
    copyError: "Error al copiar",
    gamePathError: "Ruta de juego no válida"
  }
};
